import { STAGE_ORDER, type Landing2Stage } from "@/lib/landing-v2/content"

type PanelBarProps = {
  label: string
  stage: Landing2Stage
  stageNames: [string, string, string, string]
}

function stageState(index: number, current: number) {
  if (index < current) return "done"
  if (index === current) return "active"
  return "todo"
}

/**
 * Shared top bar for the discovery, question and contact panels. The four stages
 * are the real flow, so the indicator doubles as orientation.
 */
export function PanelBar({ label, stage, stageNames }: PanelBarProps) {
  const current = Math.max(0, STAGE_ORDER.indexOf(stage))

  return (
    <div className="l2-panel-bar">
      <span className="l2-label">{label}</span>

      <p className="l2-sr" aria-live="polite">
        {`Step ${current + 1} of ${STAGE_ORDER.length}: ${stageNames[current]}`}
      </p>

      <div className="l2-flow" aria-hidden="true">
        {stageNames.map((name, index) => (
          <span key={name} className="l2-flow-step" data-state={stageState(index, current)}>
            <i className="l2-flow-dot" />
            <span className="l2-flow-name">{name}</span>
          </span>
        ))}
      </div>

      <span className="l2-flow-count" aria-hidden="true">
        <b>{String(current + 1).padStart(2, "0")}</b> / {String(STAGE_ORDER.length).padStart(2, "0")}
      </span>
    </div>
  )
}
